module.exports = "/images/zone-area.svg?f00364d16aaef66cf07e2c3925c0c698";